import PermCreate from './perm.create';
import PermEdit from './perm.edit';
import PermList from './perm.list';

export default {
  create: PermCreate,
  list: PermList,
  edit: PermEdit,
};
